<template>
  <div>

    <b-tabs>
    <b-tab :title="$t('message.Общие')" active>

    <b-form-group :label="$t('message.Название') + ':'" label-for="Name">
      <b-form-input
        id="Name"
        type="text"
        v-model="model.name"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('message.Комментарий') + ':'" label-for="Comment">
      <b-form-input
        id="Comment"
        type="text"
        v-model="model.comment"
        required
      ></b-form-input>
    </b-form-group>
    <b-row>
    <b-form-group>
      <b-form-checkbox v-model="model.enabled" switch>
        {{ $t("message.Включен") }}
      </b-form-checkbox>
    </b-form-group>
    </b-row>
    <b-form-group :label="$t('message.Адрес') + ':'" label-for="Address">
      <b-form-input
        id="Address"
        type="text"
        v-model="model.address"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('message.Обработчик') + ':'" label-for="Handler">
      <b-form-input
        id="Handler"
        type="text"
        v-model="model.handler"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group :label="$t('message.Колокейшн') + ':'" label-for="Colocation">
      <v-select
        v-model="model.colocation"
        :options="this.colocations"
        label="name"
      ></v-select>
    </b-form-group>
    <b-form-group :label="$t('message.Опции') + ':'" label-for="Options">
      <v-jsoneditor
        v-model="model.options"
        :options="options"
        :plus="false"
        @error="onJsonError"
      ></v-jsoneditor>
    </b-form-group>

    </b-tab>

    </b-tabs>

  </div>
</template>

<script>
import Vue from "vue";
import VJsoneditor from "v-jsoneditor";

export default {
  name: "VodServiceForm",
  props: ["model"],
  components: {
    VJsoneditor
  },
  data() {
    return {
      colocations: [],
      options: {
        mode: "code",
        history: false,
        search: false,
        mainMenuBar: false,
        name: this.$i18n.t("message.Опции"),
        navigationBar: false,
      },
      services: [],
      service_selected: '',
    };
  },
//   computed: {
//     hasId: function() {
//       return !!this.model.id;
//     }
//   },  
  created: function() {
    let promise_colo = this.$noname.get("colocations");

    promise_colo
      .then(data => {
        this.colocations = data.data.items;
      })
      // .catch(this.$noname.HandleError);
      .catch(error => {
        Vue.notify({
          group: "notify",
          text:
            this.$i18n.t(
              "message.Не_удалось_получить_колокейшинов"
            ) +
            ":<br>" +
            error,
          type: "error"
        });
      });
  },
  methods: {
    // getLabel(option) {
    //   return `[${option.id}] ${option.name} - ${option.address}`;
    // },
    onJsonError() {
      console.log("error");
    },
    // onValidationError: function(errors) {
    //       console.log(errors);
    //       errors.forEach(error => {
    //         switch (error.type) {
    //           case "validation": // schema validation error
    //             break;
    //           case "customValidation": // custom validation error
    //             break;
    //           case "error": // json parse error
    //             break;
    //         }
    //       });
    //     },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/VodServiceForm.vue